import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of appointment types based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(identifier) {
  return function (page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
    return baseIndex('appointment_types/'+identifier, page, itemPerPage, search, order, scheme);
  }
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single appointment type based on his ID
 *
 * @param id the of the appointment type requested
 */
export function getFromId(identifier) {
  return function (id) {
    return baseGetFromId('appointment_types/'+identifier, id);
  }
}

/**
 * Get a single product based on his ID
 *
 * @param id the of the product requested
 */
export function getIdentificationDataFromId(identifier) {
  return function (id) {
    return baseGetFromId('appointment_types/'+identifier, id, 'id');
  }
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single appointment type based on his ID
 *
 * @param id the of the appointment type requested
 * @param data the new data of the appointment type
 */
export function editFromId(identifier) {
  return function (id, data) {
    return baseEditFromId('appointment_types/'+identifier, id, data);
  }
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new appointment type
 *
 * @param data the new data of the partner
 */
export function newItem(identifier) {
  return function (data) {
    return baseNewItem('appointment_types/'+identifier, data);
  }
}


/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get the complete list of appointment types based on a pagination system
 */
export function fetchAppointmentTypes(identifier) {
  return function (search){
    return baseIndex('appointment_types/'+identifier, 1, 0, search);
  }
}
